/**
 * Created by Vaibhav on 09-03-2017.
 */
import { Injectable } from "@angular/core";
import { HttpClientService } from "../../../common/http-client.service";
import { CommonService } from "../../../common/common.service";
import {
  Http,
  Headers,
  RequestOptions,
  ResponseContentType,
} from "@angular/http";
import { ToastService } from "../../../common/toast.service";
import swal from "sweetalert2";

@Injectable()
export class LimitsService {
  active: boolean = false;
  entIdNumber: number = 0;
  loginId: any = "";
  criteriaSearchParameter: string = "MSISDN";
  idNumber: number = 0;
  constructor(
    private common: CommonService,
    private http: HttpClientService,
    private toast: ToastService
  ) {}

  // getData(param1,param2){
  //     return this.http.get("getWalletDetails/"+param1+"/"+param2+"/N", null, 8).map(res=>{return res});
  // }

  getData(data) {
    return this.http.post("limit/search/N", data, 8).map((res) => {
      return res;
    });
  }

  checkLimitName(param) {
    return this.http.get("checkLimitName/" + param, null, 8).map((res) => {
      return res;
    });
  }

  getLandingPageLimitsData(param) {
    return this.http
      .get("getLandingPageLimits/" + param + "/N", null, 8)
      .map((res) => {
        return res;
      });
  }

  getUserGroups() {
    return this.http.get("getUserGroups", null, 8).map((res) => {
      return res;
    });
  }

  getWalletType() {
    return this.http.get("getWalletTypes/101010101", null, 5).map((res) => {
      return res;
    });
  }

  getResetData(obj) {
    return this.http.post("resetLimit", obj, 8).map((res) => {
      if (res.status == "success") {
        this.toast.success("Limit Successfully Reset");
        return res;
      } else {
        this.toast.error(
          "Something went wrong. Please try again after 5" + " minutes"
        );
      }
    });
  }

  getServices(param, param1) {
    return this.http
      .get("getServices/" + param + "/" + param1, null, 8)
      .map((res) => {
        return res;
      });
  }

  getLimitType() {
    return this.http.get("getLimitType", null, 8).map((res) => {
      return res;
    });
  }

  getLimitBy() {
    return this.http.get("getLimitBy", null, 8).map((res) => {
      return res;
    });
  }

  fetchUserGroupLimitsData(param) {
    return this.http.post("getUserGroupDetails", param, 8).map((res) => {
      return res;
    });
  }

  getLimitHistory(param) {
    return this.http.get("gethistory/" + param, null, 8).map((res) => {
      return res;
    });
  }
  d;

  saveUserGroupData(param) {
    return this.http.post("saveUserGroup", param, 8).map((res) => {
      return res;
    });
  }

  updateStatus(param) {
    return this.http.post("updateStatus", param, 8).map((res) => {
      return res;
    });
  }

  //overall limit
  getEntityType() {
    return this.http.get("getEntityType/0", null, 5).map((res) => {
      return res;
    });
  }

  getEntitySubType(param) {
    return this.http.get("getEntitySubType/" + param, null, 5).map((res) => {
      return res;
    });
  }

  getOLServices() {
    return this.http.get("getAllServices", null, 8).map((res) => {
      return res;
    });
  }

  //download

  downloadIndividualWalletCsvFile(param1, param2) {
    return this.http
      .get(`downloadSingleWalletFile/` + param1 + "/" + param2, null, 8)
      .subscribe(
        (res) => {
          if (res.status === "SUCCESS" && res.object && res.object.fileData) {
            this.downloadFileFromBase64(
              res.object.fileData,
              res.object.fileName || "single_wallet_limit_details.csv",
              res.object.contentType || "text/csv"
            );
          } else {
            let errorMessage = "Failed to download file. Please try again.";
            if (res.message) {
              errorMessage = res.message;
            }
            swal({
              title: "Error",
              text: errorMessage,
              type: "error",
              showCancelButton: false,
              confirmButtonText: "OK",
            });
          }
        },
        (error) => {
          swal({
            title: "Error",
            text: "Error downloading file. Please try again.",
            type: "error",
            showCancelButton: false,
            confirmButtonText: "OK",
          });
        }
      );
  }

  downloadcsv(data, userId) {
    let a = document.createElement("a");
    a.setAttribute("id", "downloadCsv");
    let date = new Date();
    let Tdate =
      date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
    a.download = userId + ".csv";
    a.href = window.URL.createObjectURL(data);
    a.textContent = "Download CSV";
    a.dataset.downloadurl = [
      "text/csv;charset=ISO-8859-1",
      a.download,
      a.href,
    ].join(":");
    document.body.appendChild(a);
    setTimeout(function () {
      document.getElementById("downloadCsv").click();
      document.getElementById("downloadCsv").remove();
    }, 1000);
  }
  downloadCsvFileCheck(queryString) {
    let headObj: any = {
      // 'userId': this.common.getUserId(),
      Authorization: localStorage.getItem("tkn"),
    };
    let headers = new Headers(headObj);
    let reqHead = new RequestOptions({
      responseType: ResponseContentType.Blob,
      headers: headers,
    });
    return this.http
      .get(
        "downloadGroupOverallLimitFile?" + queryString,
        null,
        8,
        reqHead,
        "blob"
      )
      .map((res) => {
        // this.downloadcsv(data, 'user_limits');
        return res;
      });
  }

  downloadLandingLimits(param, fileType: string = "csv") {
    var fileName = "UserGroup_Landing_Limits";
    if (!param) {
      fileName = "Overall_Landing_limits";
    }

    const fileExtension = fileType === "xlsx" ? ".xlsx" : ".csv";

    return this.http
      .get(`downloadLandingPageLimits/${param}?fileType=${fileType}`, null, 8)
      .subscribe(
        (res) => {
          if (res.status === "SUCCESS" && res.object && res.object.fileData) {
            this.downloadFileFromBase64(
              res.object.fileData,
              res.object.fileName || fileName + fileExtension,
              res.object.contentType
            );
          } else {
            let errorMessage = "Failed to download file. Please try again.";
            if (res.message) {
              errorMessage = res.message;
            } else if (res.object && res.object.message) {
              errorMessage = res.object.message;
            } else if (res.error && res.error.message) {
              errorMessage = res.error.message;
            }
            swal({
              title: "Error",
              text: errorMessage,
              type: "error",
              showCancelButton: false,
              confirmButtonText: "OK",
              confirmButtonColor: "#3085d6",
            }).then(
              (success) => {},
              (dismiss) => {}
            );
          }
        },
        (error) => {
          let errorMessage = "Error downloading file. Please try again.";

          if (error && error._body) {
            try {
              const parsedError =
                typeof error._body === "string"
                  ? JSON.parse(error._body)
                  : error._body;
              if (parsedError && parsedError.message) {
                errorMessage = parsedError.message;
              }
            } catch (e) {}
          }

          if (error && error.error) {
            if (typeof error.error === "string") {
              try {
                const parsedError = JSON.parse(error.error);
                if (parsedError && parsedError.message) {
                  errorMessage = parsedError.message;
                }
              } catch (e) {
                errorMessage = error.error;
              }
            } else if (error.error.message) {
              errorMessage = error.error.message;
            } else if (error.error._body) {
              try {
                const parsedError = JSON.parse(error.error._body);
                if (parsedError && parsedError.message) {
                  errorMessage = parsedError.message;
                }
              } catch (e) {}
            }
          } else if (error && error.message) {
            errorMessage = error.message;
          }

          swal({
            title: "Error",
            text: errorMessage,
            type: "error",
            showCancelButton: false,
            confirmButtonText: "OK",
            confirmButtonColor: "#3085d6",
          }).then(
            (success) => {},
            (dismiss) => {}
          );
        }
      );
  }

  downloadFile(data, fileName) {
    let a = document.createElement("a");
    a.setAttribute("id", "downloadFile");
    a.download = fileName;
    a.href = window.URL.createObjectURL(data);
    a.textContent = "Download File";

    const mimeType = fileName.endsWith(".xlsx")
      ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      : "text/csv;charset=ISO-8859-1";

    a.dataset.downloadurl = [mimeType, a.download, a.href].join(":");

    document.body.appendChild(a);
    setTimeout(function () {
      document.getElementById("downloadFile").click();
      document.getElementById("downloadFile").remove();
    }, 1000);
  }

  /**
   * Download file from base64 encoded data
   * @param base64Data - Base64 encoded file data
   * @param fileName - Name of the file to download
   * @param contentType - MIME type of the file (e.g., "text/csv" or "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
   */
  downloadFileFromBase64(
    base64Data: string,
    fileName: string,
    contentType: string
  ) {
    try {
      // Decode base64 to binary string
      const binaryString = atob(base64Data);

      // Convert binary string to byte array
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      // Create blob from byte array
      const blob = new Blob([bytes], { type: contentType || "text/csv" });

      // Create download link and trigger download
      const a = document.createElement("a");
      a.setAttribute("id", "downloadFileBase64");
      a.download = fileName;
      a.href = window.URL.createObjectURL(blob);
      a.style.display = "none";

      document.body.appendChild(a);
      setTimeout(() => {
        a.click();
        document.body.removeChild(a);
        // Clean up the object URL
        window.URL.revokeObjectURL(a.href);
      }, 100);
    } catch (error) {
      this.toast.error("Error processing file download. Please try again.");
    }
  }

  checkDataExists(param, param1, param2) {
    return this.http
      .get("checkDataExists/" + param + "/" + param1 + "/" + param2, null, 8)
      .map((res) => {
        return res;
      });
  }

  downloadFilteredData(
    userGrpId,
    entityType,
    entitySubType,
    fileType: string = "csv"
  ) {
    // Use "Overall_limits" if userGrpId is 0 (overall limits), otherwise "User_Group_limits"
    var fileName = userGrpId === 0 ? "Overall_limits" : "User_Group_limits";
    const fileExtension = fileType === "xlsx" ? ".xlsx" : ".csv";

    return this.http
      .get(
        `downloadFilteredData/${userGrpId}/${entityType}/${entitySubType}?fileType=${fileType}`,
        null,
        8
      )
      .subscribe(
        (res) => {
          // Check if response status is SUCCESS and has file data
          if (res.status === "SUCCESS" && res.object && res.object.fileData) {
            this.downloadFileFromBase64(
              res.object.fileData,
              res.object.fileName || fileName + fileExtension,
              res.object.contentType
            );
          } else {
            // Handle error response (HTTP 200 but error in response)
            // Show backend error message from response
            // Extract error message from response - check multiple possible locations
            let errorMessage = "Failed to download file. Please try again.";
            if (res.message) {
              errorMessage = res.message;
            } else if (res.object && res.object.message) {
              errorMessage = res.object.message;
            } else if (res.error && res.error.message) {
              errorMessage = res.error.message;
            }
            swal({
              title: "Error",
              text: errorMessage,
              type: "error",
              showCancelButton: false,
              confirmButtonText: "OK",
              confirmButtonColor: "#3085d6",
            }).then(
              (success) => {},
              (dismiss) => {}
            );
          }
        },
        (error) => {
          // Handle HTTP error - try to get error message from response
          let errorMessage = "Error downloading file. Please try again.";

          // Try to extract message from different error response structures
          // Check _body first (Response object with _body as JSON string)
          if (error && error._body) {
            try {
              const parsedError =
                typeof error._body === "string"
                  ? JSON.parse(error._body)
                  : error._body;
              if (parsedError && parsedError.message) {
                errorMessage = parsedError.message;
              }
            } catch (e) {
              // If parsing fails, continue to other checks
            }
          }

          // Check error.error structure
          if (error && error.error) {
            // If error.error is a string (parsed JSON), try to parse it
            if (typeof error.error === "string") {
              try {
                const parsedError = JSON.parse(error.error);
                if (parsedError && parsedError.message) {
                  errorMessage = parsedError.message;
                }
              } catch (e) {
                // If parsing fails, use the string as is
                errorMessage = error.error;
              }
            } else if (error.error.message) {
              // If error.error is an object with message
              errorMessage = error.error.message;
            } else if (error.error._body) {
              // Try to parse _body if it exists
              try {
                const parsedError = JSON.parse(error.error._body);
                if (parsedError && parsedError.message) {
                  errorMessage = parsedError.message;
                }
              } catch (e) {
                // Ignore parsing errors
              }
            }
          } else if (error && error.message) {
            errorMessage = error.message;
          }

          swal({
            title: "Error",
            text: errorMessage,
            type: "error",
            showCancelButton: false,
            confirmButtonText: "OK",
            confirmButtonColor: "#3085d6",
          }).then(
            (success) => {},
            (dismiss) => {}
          );
        }
      );
  }

  downloadCsvFile(queryString, fileName) {
    let headObj: any = {
      // 'userId': this.common.getUserId(),
      Authorization: localStorage.getItem("tkn"),
    };
    let headers = new Headers(headObj);
    let reqHead = new RequestOptions({
      responseType: ResponseContentType.Blob,
      headers: headers,
    });
    return this.http
      .get(
        "downloadGroupOverallLimitFile?" + queryString,
        null,
        8,
        reqHead,
        "blob"
      )
      .subscribe((data) => {
        this.downloadcsv(data, fileName);
      });
  }
}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/main/limits-capping/limits-wallet/limits.service.ts